import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  KnBrasmTranslationChunksConfig,
  KnBrasmTranslations,
} from 'src/feature-libs/kn-br-asm/assets/translations/translation';
import { AsmRootModule } from 'src/feature-libs/kn-br-asm/root/asm-root.module';
import { ASM_FEATURE } from 'src/feature-libs/kn-br-asm/root/feature-name';

@NgModule({
  imports: [AsmRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [ASM_FEATURE]: {
          module: () => import('../../../../feature-libs/kn-br-asm/kn-br-asm.module').then((m) => m.KnBrAsmModule),
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: KnBrasmTranslations,
        chunks: KnBrasmTranslationChunksConfig,
      },
    } as I18nConfig),
  ],
})
export class AsmFeatureModule { }
